/*
 * Palo Alto Theme
 *
 * Use this file to add custom Javascript to Palo Alto.  Keeping your custom
 * Javascript in this fill will make it easier to update Palo Alto. In order
 * to use this file you will need to open layout/theme.liquid and uncomment
 * the custom.js script import line near the bottom of the file.
 */

(function () {
  // Add custom code below this line

  let prevScrollPos = window.pageYOffset;
  window.addEventListener("scroll", () => {
    let currentScrollPos = window.pageYOffset;
    if (currentScrollPos < 200) {
      prevScrollPos = currentScrollPos;
      return;
    }
    if (prevScrollPos > currentScrollPos) {
      document.getElementById("SiteHeader").style.top = "0";
    } else {
      document.getElementById("SiteHeader").style.top = "-92px";
    }
    prevScrollPos = currentScrollPos;
  });

  if (!customElements.get("remove-multiple-button"))
    customElements.define(
      "remove-multiple-button",
      class extends HTMLElement {
        constructor() {
          super();
        }

        connectedCallback() {
          this.url = this.getAttribute("data-url");
          this.addEventListener("click", this.handleClick);
        }

        handleClick(e) {
          e.preventDefault();
          fetch(this.url).then(() => { if (cart) { cart.getCart(); } });
        }
      }
    );

  class CartWatcher {
    init() {
      this.emitCartChanges().then(() => {
        this.observeCartChanges();
      });
    }

    async fetchCart() {
      const response = await fetch("/cart.js");
      return response.json();
    }

    storeCart(cart) {
      localStorage.setItem("cart", JSON.stringify(cart));
    }

    storedCart() {
      return JSON.parse(localStorage.getItem("cart")) || { items: [] };
    }

    findCartChanges(oldCart, newCart) {
      const onlyInLeft = (l, r) =>
        l.filter((li) => !r.some((ri) => li.key == ri.key));
      let result = {
        added: onlyInLeft(newCart.items, oldCart.items),
        removed: onlyInLeft(oldCart.items, newCart.items),
        cart: newCart,
      };

      oldCart.items.forEach((oi) => {
        const ni = newCart.items.find(
          (i) => i.key == oi.key && i.quantity != oi.quantity
        );
        if (!ni) return;
        let quantity = ni.quantity - oi.quantity;
        let item = { ...ni };
        item.quantity = Math.abs(quantity);
        quantity > 0 ? result.added.push(item) : result.removed.push(item);
      });

      return result;
    }

    async emitCartChanges() {
      const newCart = await this.fetchCart();
      const oldCart = this.storedCart();
      const changes = this.findCartChanges(oldCart, newCart);

      const event = new CustomEvent("cart_changed", { detail: changes });
      window.dispatchEvent(event);

      this.storeCart(newCart);
    }

    observeCartChanges() {
      const cartObserver = new PerformanceObserver((list) => {
        list.getEntries().forEach((entry) => {
          const isValidRequestType = ["xmlhttprequest", "fetch"].includes(
            entry.initiatorType
          );
          const isCartChangeRequest = /\/cart\//.test(entry.name);
          if (isValidRequestType && isCartChangeRequest) {
            this.emitCartChanges();
          }
        });
      });
      cartObserver.observe({ entryTypes: ["resource"] });
    }
  }
  document.addEventListener(
    "DOMContentLoaded",
    () => {
      new CartWatcher().init();
    },
    { once: true }
  );
  /*window.addEventListener("cart_changed", e => console.log(e.detail));*/
  /*(function(ns, fetch) {
    if (typeof fetch !== 'function') return;
  
    ns.fetch = function() {
      console.log(this, arguments);
      const out = fetch.apply(this, arguments);
      
      // side-effect
      out.then(({ ok }) => console.log('loaded', ok));
  
      return out;
    }
  
  }(window, window.fetch))*/

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
